import React, { useEffect } from "react";
import { verifyAdminToken } from "helpers/backend_helper";
import { decryptDataFromArray } from "helpers/EncDec";
import { Redirect, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const LoginSSO = props => {
  const params = useParams();

  const verifyAdminTokenHelper = async token => {
    try {
      let response = await verifyAdminToken(token);

      response = decryptDataFromArray(response);

      localStorage.setItem("authUser", JSON.stringify(response));
      localStorage.setItem("auth_token", response?.accessToken);
      localStorage.setItem("user_info", JSON.stringify(response?.user));
      localStorage.setItem("user_id", JSON.stringify(response?.user.id));
      localStorage.setItem("logintime", JSON.stringify(new Date()));

      window.location.href = "/dashboard";
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err?.message || "Error logging in"
      );
      window.location.href = "/access-denied";

      return;
    }
  };
  
  let token = params?.token;


useEffect(() => {
  verifyAdminTokenHelper(token);
}, []);

if (!token) {
  return <Redirect to="/access-denied" />;
}

  return (
    <div className="text-center mt-5 pt-5 d-flex gap-3 justify-content-around">
      <div className="mt-5 pt-5 d-flex justify-content-center align-items-center flex-column">
        <h1>Please Wait ...</h1>
        <p>Please wait for a few seconds, we are redirecting you.</p>
      </div>
    </div>
  );
};

export default LoginSSO;
